<ng-template #illegal>
    <app-page403></app-page403>
</ng-template>

<card *ngIf="!illegalUser; else illegal">
    <div *ngIf="isFetching==false || searchResultData== false ; else spin">
        <div *ngIf="searchResult?.analysisStatus !== 'NewAnalysis'">
            <div class="col-md-6"><strong> RedThread User Name:</strong>
                {{searchResult?.analyst_name}}
            </div>
            <div class="col-md-6"><strong> RedThread Analysis Date (UTC):</strong>
                {{searchResult?.analysis_date}}
            </div>
            <div class="col-md-6"><strong> Analysis Type:</strong>
                {{searchResult?.analysisType}}
            </div>
            <div class="col-md-6"><strong> Project Code:</strong>
                {{searchResult?.projectCode}}
            </div>
            <div class="col-md-6" *ngIf="searchResult?.study"><strong> Study:</strong>
                {{getDisplayString(searchResult?.study)}}
            </div>
            <div class="col-md-6"><strong>Target Names</strong></div>

            <mat-accordion class="grid-container">
                <div *ngFor="let target of searchResult?.TargetNames; let i = index" class="grid-item">

                    <mat-expansion-panel style="margin-bottom: 20px;"
                        [ngClass]="{'panel-ql': target.TargetType === 'QL','panel-saved': savedTargetData[target.targetName]}"  data-cy="expand-target">
                        <mat-expansion-panel-header>
                            <mat-panel-title><strong>Target Name:
                                    {{target?.targetName }}</strong></mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="grid-content">
                            <div><strong>Target Type:</strong>
                                {{ getDisplayString(target?.TargetType) }}
                            </div>
                        </div>
                        <div *ngIf="target.TargetType === 'QL'" class="grid-content">
                            <div><strong>Negative Reverse Transcriptase Control Sample
                                    Included:</strong>
                                {{ target.QL?.QLRTsamples === 'True' ? 'Yes':'No'}}
                            </div>
                            <div><strong>Intra %CV Threshold of Replicate Ct Values:</strong>
                                {{target.QL?.Intra_percent_CV }}
                            </div>
                            <div>
                                <strong>%CV Threshold of Housekeeping and Test Sample Ct
                                    Values:</strong>{{target.QL?.Threshold_CV}}
                            </div>
                        </div>

                        <div *ngIf="target.TargetType === 'QT'" class="grid-content">
                            <div><strong>Negative Reverse Transcriptase Control Sample Included:</strong>
                                {{ target.QT?.QTRTsamples === 'True' ? 'Yes':'No' }}
                            </div>
                            <div
                                *ngIf=" target.QT?.contaminationThreshold && target.QT?.contaminationThreshold !== null">
                                <strong> %Contamination
                                    Threshold:</strong>
                                {{ getDisplayString(target.QT?.contaminationThreshold) }}
                            </div>
                            <div><strong> Spiked Samples Used:</strong>
                                {{ target.QT?.SpikeSamples === 'True' ? 'Yes':'No' }}
                            </div>
                            <div *ngIf="target.QT?.spikeCopies && target.QT?.spikeCopies !== null"><strong>Number of
                                    Spiked Copies:</strong>
                                {{ target.QT?.spikeCopies }}
                            </div>
                            <div *ngIf="target.QT?.recoveryThreshold && target.QT?.recoveryThreshold !== null">
                                <strong>%Recovery Threshold:</strong>
                                {{getDisplayString(target.QT?.recoveryThreshold) }}
                            </div>
                            <div><strong>Inhibition Samples Used:</strong>
                                {{ target.QT?.InhibitionSamples === 'True' ? 'Yes':'No' }}
                            </div>
                            <div *ngIf="target.QT?.spikeCopies2 && target.QT?.spikeCopies2 !== null"><strong> Number of
                                    Spiked Copies if Inhibition
                                    Samples
                                    Used:</strong>
                                {{ target.QT?.spikeCopies2 }}
                            </div>
                            <div><strong>General Inter Precision %CV for Back Calculated
                                    Value:</strong>
                                {{target.QT?.Gen_Inter_prec_CV_Back_Calc}}
                            </div>
                            <div><strong>LLOQ/ULOQ Inter Precision %CV for Back Calculated
                                    Value:</strong>
                                {{target.QT?.LLOQ_ULOQ_Inter_prec_CV_Back_Calc}}
                            </div>

                            <div><strong>General Intra and Inter Accuracy %RE for Back Calculated
                                    Value:</strong>
                                {{target.QT?.Gen_Intra_Inter_Acc_RE_Back_Calc}}
                            </div>
                            <div><strong>LLOQ/ULOQ Inter and Intra Accuracy %RE for Back
                                    Calculated
                                    Value:</strong>
                                {{target.QT?.ULOQ_LLOQ_Inter_Intra_RE_Back_Calc}}
                            </div>
                            <div><strong>Lower Slope Value:</strong>
                                {{target.QT?.Lower_Slope_Value}}
                            </div>

                            <div><strong>Higher Slope Value:</strong>
                                {{target.QT?.Higher_Slope_Value}}
                            </div>

                            <div *ngIf="target.QT?.Cq.Intra_prec_CV_Cq !== null"><strong>Intra Precision %CV for Cq
                                    Value:</strong>
                                {{target.QT?.Cq.Intra_prec_CV_Cq}}
                            </div>

                            <div *ngIf="target.QT?.BackCalculated.Gen_Intra_prec_CV_Back_Calc !== null"><strong>General
                                    Intra Precision %CV for Back Calculated
                                    Value:</strong>
                                {{target.QT?.BackCalculated.Gen_Intra_prec_CV_Back_Calc}}
                            </div>
                            <div *ngIf="target.QT?.BackCalculated.LLOQ_ULOQ_Intra_prec_CV_Back_Calc !== null">
                                <strong>LLOQ/ULOQ Intra Precision %CV for Back Calculated
                                    Value:</strong>
                                {{target.QT?.BackCalculated.LLOQ_ULOQ_Intra_prec_CV_Back_Calc}}
                            </div>

                            <div><strong>True LLOQ Nominal Value:</strong>
                                {{target.QT?.QualityControls.LLOQ_QC}}
                            </div>
                            <div><strong>Low QC Nominal Value:</strong>
                                {{target.QT?.QualityControls.Low_QC}}
                            </div>
                            <div><strong>Mid QC Nominal Value:</strong>
                                {{target.QT?.QualityControls.Mid_QC}}
                            </div>
                            <div><strong>High QC Nominal Value:</strong>
                                {{target.QT?.QualityControls.High_QC}}
                            </div>
                            <div><strong>True ULOQ Nominal Value:</strong>
                                {{target.QT?.QualityControls.ULOQ_QC}}
                            </div>
                        </div>
                        <div class="target-container"
                            *ngIf="(searchResult.analysisStatus==='Complete' || (searchResult.analysisStatus=== 'Pending' && target.TargetType === 'QL'))">
                            <div class="icon">
                                <p><strong> RedThread Analysis Report
                                        ({{target.targetName }}-{{ target.TargetType}})
                                    </strong></p>
                                <a target="_blank" href="{{signedpath}}"
                                    (click)="getOutputFilePath(target.targetName,target.output_result_path)">
                                    <file [type]="'xlsx'" [title]="'RedThread Analysis Report'"></file>
                                </a>
                            </div>
                        </div>
                    </mat-expansion-panel>

                </div>
            </mat-accordion>

            <div class="col-md-6" *ngIf="searchResult.analysisType ==='qPCR'"><strong>Uploaded Files:</strong>
                <ol>
                    <li *ngFor="let file of searchResult.files">{{file}}</li>
                </ol>
            </div>
        </div>
        <br>
        <div *ngIf="searchResult.analysisStatus==='Complete' || searchResult.analysisStatus==='Pending'">
            <div class="icon-container">
                <div class="icon">
                    <p><strong>RedThread Audit Report</strong></p>
                    <a *ngIf="!fetchingEventData" target="_blank" (click)="exportAuditPDF()" data-cy="audit-download"
                        style="cursor: pointer; color:#5DADE0;">
                        <file [type]="'pdf'" [title]="'RedThread Audit Report'"></file>
                    </a>
                    <div *ngIf="fetchingEventData" style="display: flex; align-items: center; gap: 8px;">
                        <div class="spinner">
                        </div>
                        <b>
                            <p style="color: #5DADE0">Loading...</p>
                        </b>
                    </div>

                </div>

                <div class="icon" *ngIf="searchResult.analysisType === 'qPCR'">
                    <p><strong>RedThread User Uploaded File(s) Report</strong></p>
                    <a *ngIf="searchResult?.pdf_file_path" target="_blank" (click)="exportPDF()"
                        style="cursor: pointer;color:#5DADE0;" href="{{usersignedpath}}">
                        <file [type]="'pdf'" [title]="'RedThread User Uploaded File(s) Report'"></file>
                    </a>
                    <a *ngIf="searchResult?.pdf_data" target="_blank" (click)="exportPDF()"
                        style="cursor: pointer;color:#5DADE0;">
                        <file [type]="'pdf'" [title]="'RedThread User Uploaded File(s) Report'"></file>
                    </a>
                </div>
            </div>

            <div><strong>Disclaimer</strong></div>
            <div style='font-size:80%; margin-bottom: 30px;'>Red Thread is not a replacement for any quality control or
                quality
                assurance process. BioData Solutions does not guarantee the accuracy of the
                results of the software. To the fullest extent permitted under
                applicable law, BioData Solutions is not liable for any event or loss related
                to the reliance on Red Thread or the output produced by Red Thread.
            </div>

            <div id="htmlData" #htmlData="" style="display: none;">
                <div *ngFor="let data of QpcrPdfData">

                    <span class="heading"><strong> {{data.file_number}}. {{data.file_name}}</strong></span>
                    <table
                        style=" width: 100%; margin-bottom: 20px; margin-top: 10px; margin-left: 42px;margin-right: 0px; border: 0.2pt; text-align:left"
                        class="table-striped">
                        <thead>
                            <tr>
                                <!-- <th *ngFor="let column of data?.table?.data[0] | keyvalue " >{{column.key}}</th> -->
                                <th
                                    style=" color: white;
                                font-size: 8pt;background-color: #7787a6;font-weight: bold;padding: 4px 10px 4px 5px;justify-content: center;align-items: left;border: 0.2pt; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    Target Name</th>
                                <th
                                    style=" color: white;
                                font-size: 8pt;background-color: #7787a6;font-weight: bold;padding: 4px 10px 4px 5px;justify-content: center;align-items: left;border: 0.2pt; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    Well Position</th>
                                <th
                                    style=" color: white;
                                    font-size: 8pt;background-color: #7787a6;font-weight: bold;padding: 4px 10px 4px 5px;justify-content: center;align-items: left;border: 0.2pt; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    Sample</th>
                                <th
                                    style=" color: white;
                                    font-size: 8pt;background-color: #7787a6;font-weight: bold;padding: 4px 10px 4px 5px;justify-content: center;align-items: left;border: 0.2pt; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    Quantity</th>
                                <th
                                    style=" color: white;
                                    font-size: 8pt;background-color: #7787a6;font-weight: bold;padding: 4px 10px 4px 5px;justify-content: center;align-items: left;border: 0.2pt; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    Task</th>
                                <th
                                    style=" color: white;
                                    font-size: 8pt;background-color: #7787a6;font-weight: bold;padding: 4px 10px 4px 5px;justify-content: center;align-items: left;border: 0.2pt; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    Cq</th>
                                <th *ngIf="hasRegressionData"
                                    style=" color: white;
                                    font-size: 8pt;background-color: #7787a6;font-weight: bold;padding: 4px 10px 4px 5px;justify-content: center;align-items: left;border: 0.2pt; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    Slope</th>
                                <th *ngIf="hasRegressionData"
                                    style=" color: white;
                                    font-size: 8pt;background-color: #7787a6;font-weight: bold;padding: 4px 10px 4px 5px;justify-content: center;align-items: left;border: 0.2pt; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    Y-Intercept</th>
                                <th *ngIf="hasRegressionData"
                                    style=" color: white;
                                    font-size: 8pt;background-color: #7787a6;font-weight: bold;padding: 4px 10px 4px 5px;justify-content: center;align-items: left;border: 0.2pt; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    R2</th>

                            </tr>

                        </thead>
                        <tbody>
                            <ng-container *ngFor="let row of data.table.data ">
                                <tr>
                                    <ng-container>
                                        <!-- <ng-container *ngFor="let value of row | keyvalue"> -->
                                        <!-- <td >{{ value.value }}</td> -->
                                        <td
                                            style="font-size: 8pt; padding: 4px 10px 4px 5px;text-align: left;word-wrap: break-word; border: 0.2pt;  overflow: hidden; text-overflow: ellipsis;">
                                            {{row?.target}}</td>
                                        <td
                                            style="font-size: 8pt; padding: 4px 10px 4px 5px;text-align: left;word-wrap: break-word; border: 0.2pt;  overflow: hidden; text-overflow: ellipsis;">
                                            {{row?.well_position}}</td>
                                        <td
                                            style="font-size: 8pt; padding: 4px 10px 4px 5px;text-align: left;word-wrap: break-word; border: 0.2pt;  overflow: hidden; text-overflow: ellipsis;">
                                            {{row?.sample}}</td>
                                        <td
                                            style="font-size: 8pt; padding: 4px 10px 4px 5px;text-align: left;word-wrap: break-word; border: 0.2pt;  overflow: hidden; text-overflow: ellipsis;">
                                            {{row?.quantity}}</td>
                                        <td
                                            style="font-size: 8pt; padding: 4px 10px 4px 5px;text-align: left;word-wrap: break-word; border: 0.2pt;  overflow: hidden; text-overflow: ellipsis;">
                                            {{row?.task}}</td>
                                        <td
                                            style="font-size: 8pt; padding: 4px 10px 4px 5px;text-align: left;word-wrap: break-word; border: 0.2pt;  overflow: hidden; text-overflow: ellipsis;">
                                            {{row?.cq}}</td>
                                        <td *ngIf="hasRegressionData"
                                            style="font-size: 8pt; padding: 4px 10px 4px 5px;text-align: left;word-wrap: break-word; border: 0.2pt;  overflow: hidden; text-overflow: ellipsis;">
                                            {{row?.slope}}</td>
                                        <td *ngIf="hasRegressionData"
                                            style="font-size: 8pt; padding: 4px 10px 4px 5px;text-align: left;word-wrap: break-word; border: 0.2pt;  overflow: hidden; text-overflow: ellipsis;">
                                            {{row?.y_intercept}}</td>
                                        <td *ngIf="hasRegressionData"
                                            style="font-size: 8pt; padding: 4px 10px 4px 5px;text-align: left;word-wrap: break-word; border: 0.2pt;  overflow: hidden; text-overflow: ellipsis;">
                                            {{row?.r2}}</td>

                                    </ng-container>
                                </tr>
                            </ng-container>

                        </tbody>
                    </table>


                </div>
            </div>

            <div id="auditData" #auditData="" *ngIf="AuditPdfData?.data?.data?.length" style="display: none;">
                <table
                    style=" width: 100%; margin-bottom: 20px;margin-top: 10px; margin-left: 30px; margin-right: 30px;text-align:left; border: 0.2pt;">
                    <thead>
                        <tr>
                            <th *ngFor="let col of AuditPdfData?.data.data[0] | keyvalue
                    " style=" color: white;
                    font-size: 8pt; background-color: #7787a6;font-weight: bold; padding: 10px 10px 10px 10px;justify-content: center;align-items: left;border: 0.2pt;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                {{col.key}}</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngFor="let value of AuditPdfData?.data.data ">

                            <td *ngFor="let value of value | keyvalue"
                                style="font-size: 8pt; padding: 10px 10px 10px 10px;
                        text-align: left;word-wrap: break-word; border: 0.2pt; overflow: hidden; text-overflow: ellipsis;">{{ value.value }}</td>

                        </tr>

                    </tbody>
                </table>
            </div>

            <div *ngIf="graphHistoryData?.length>0">
                <h5>Data Handling Summary </h5>
                <div *ngFor="let iterationData of graphHistoryData">
                    <strong><u>For Target - {{iterationData?.target }}</u></strong>
                    <h6>Iteration {{ iterationData?.iteration }}</h6>
                    <table>
                        <thead>
                            <tr>
                                <th>Run ID</th>
                                <th>Intercept</th>
                                <th>Slope</th>
                                <th>R-Squared</th>
                                <th>Deactivated Samples</th>
                                <th>Comment</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let runData of iterationData.data">
                                <tr>
                                    <td rowspan="{{ runData.comments.length }}">{{ runData?.run_id }}</td>
                                    <td rowspan="{{ runData.comments.length }}">{{ runData?.intercept }}</td>
                                    <td rowspan="{{ runData.comments.length }}">{{ runData?.slope }}</td>
                                    <td rowspan="{{ runData.comments.length }}">{{ runData?.R_Square }}</td>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr
                                                    *ngFor="let comment of runData.comments.length > 0 ? runData.comments : [null]">
                                                    <td *ngIf="comment?.CQ">{{ comment?.sample_id || 'No Deactivated
                                                        Samples' }} (Only Ct {{comment?.CQ}})</td>
                                                    <td *ngIf="!comment?.CQ">{{ comment?.sample_id || 'No Deactivated
                                                        Samples' }}</td>

                                                </tr>

                                            </tbody>
                                        </table>
                                    </td>

                                    <td>
                                        <table>
                                            <tbody>
                                                <tr
                                                    *ngFor="let comment of runData.comments.length > 0 ? runData.comments : [null]">
                                                    <td>{{ comment?.comment || 'No Comments' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>

            </div>

            <mat-form-field *ngIf="graphdata?.length > 0">
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
            </mat-form-field>

            <div *ngIf="filteredData == null">
                No Matching Results Found.
            </div>
            <div *ngIf="graphdata?.length > 0 || searchResult.CompileRuns?.length >0">
                <mat-form-field appearance="outline" class="target-dropdown">
                    <mat-label>Select Target Name</mat-label>
                    <mat-select [(value)]="selectedTargetName" (selectionChange)="onTargetChange($event.value)" data-cy="target-name-select">
                        <mat-option *ngFor="let name of targetNames" [value]="name">
                            {{ name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <strong *ngIf="selectedTargetName">For Target - {{selectedTargetName}}</strong>
            <br>
            <div *ngIf="selectedTargetName && searchResult.CompileRuns?.length >0" class="table-container">

                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 custom-table">

                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>Select</th>
                        <td mat-cell *matCellDef="let run">
                            <mat-checkbox [checked]="run.flag" [disabled]="true"></mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="run_id">
                        <th mat-header-cell *matHeaderCellDef>Run ID</th>
                        <td mat-cell *matCellDef="let run">{{ run.run_id }}</td>
                    </ng-container>

                    <ng-container matColumnDef="target_type">
                        <th mat-header-cell *matHeaderCellDef>Target Type</th>
                        <td mat-cell *matCellDef="let run">{{ run.target_type }}</td>
                    </ng-container>

                    <ng-container matColumnDef="run_status">
                        <th mat-header-cell *matHeaderCellDef>Run Status</th>
                        <td mat-cell *matCellDef="let run">{{ run.run_status }}</td>
                    </ng-container>

                    <ng-container matColumnDef="username">
                        <th mat-header-cell *matHeaderCellDef>Username</th>
                        <td mat-cell *matCellDef="let run">{{ run.username }}</td>
                    </ng-container>

                    <ng-container matColumnDef="analysis_date">
                        <th mat-header-cell *matHeaderCellDef>Analysis Date</th>
                        <td mat-cell *matCellDef="let run">{{ run.analysis_date }}</td>
                    </ng-container>

                    <ng-container matColumnDef="project_code">
                        <th mat-header-cell *matHeaderCellDef>Project Code</th>
                        <td mat-cell *matCellDef="let run">{{ run.project_code }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                </table>
                <div>
                    <mat-paginator #RApaginator [pageSizeOptions]="[10, 20]" [length]="dataSource" showFirstLastButtons></mat-paginator>
                </div>
            </div>
            <div *ngIf="paginatedData && selectedTargetName">
                <div *ngFor="let dataObj of paginatedData?.connect() | async;let i=index">
                    <mat-expansion-panel [(expanded)]="panelStates[dataObj?.target_name + '_' + dataObj?.run_id]"
                        (opened)="handlePanelOpened(dataObj, i)" data-cy="target-expansion">
                        <mat-expansion-panel-header class="custom-panel-header">
                            <mat-panel-title><strong>{{ dataObj?.run_id }}</strong></mat-panel-title>
                            <div class="header-right" *ngIf="dataObj?.save">
                                <mat-icon color="success" data-cy="save-success-icon">check_circle</mat-icon>
                                <span>Data Saved</span>
                            </div>
                        </mat-expansion-panel-header>
                        <div id="{{'plotlyDiv_' + dataObj?.target_name+ dataObj?.run_id}}"
                            style="width: 100%; height: 400px;"></div>

                        <div
                            *ngIf="!recalculationStates[dataObj?.target_name + '_' + dataObj?.run_id]; else Recalculate">
                            <p><b>Slope = </b>{{dataObj?.slope}}</p>
                            <p><b>Intercept = </b> {{dataObj?.intercept}}</p>
                            <p><b>R-Squared = </b>{{dataObj?.R_Square}}</p>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Select</th>
                                        <th>Sample Name</th>
                                        <th>Quantity Log10</th>
                                        <th *ngIf="searchResult.study ==='N3'">Select Individual Ct Value</th>
                                        <th>Ct</th>
                                        <th>Ct_CV</th>
                                        <th>BC Quantity</th>
                                        <th>Individual %RE</th>
                                        <th>%BC_CV</th>
                                        <th>%RE</th>
                                        <th *ngIf="hasSelectedCheckboxes(dataObj)">Comments</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let sample of dataObj.table_data.data; let j = index; trackBy: trackBySampleId">
                                        <td><input type="checkbox" [checked]="sample.flag"
                                                [disabled]="searchResult.iteration === 1"
                                                (change)="toggleSelection(dataObj,sample,i,j)" data-cy="sample-checkbox"/></td>
                                        <td>{{ sample.sample }}</td>
                                        <td *ngIf="sample?.quantity_log10">{{ sample.quantity_log10 }}
                                        </td>
                                        <td *ngIf="searchResult.study ==='N3'">
                                            <table>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let cqflag of sample.individual_sample_flag; let k = index;trackBy: trackByIndex">
                                                        <td [id]="k">
                                                            <input type="checkbox" [checked]="cqflag"
                                                                [disabled]="isCheckboxDisabled(sample.individual_sample_flag, k)|| (searchResult.iteration === 1) || sample.flag"
                                                                (change)="toggleCqSelection(dataObj, sample, k,i)"
                                                                [class.checked]="cqflag" />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </td>
                                        <td>
                                            <table>
                                                <tbody>
                                                    <tr *ngFor="let cq of sample?.cq">
                                                        <td>{{cq}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td>{{ sample.cq_cv}}</td>
                                        <td>
                                            <table>
                                                <tbody>
                                                    <tr *ngFor="let bc of sample?.bc_quantity">
                                                        <td>{{bc}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td>
                                            <table>
                                                <tbody>
                                                    <tr *ngFor="let re of sample?.individual_re">
                                                        <td>{{re}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td>{{sample.bc_cv }}</td>
                                        <td>{{sample.bc_re}}</td>

                                        <td *ngIf="shouldDisplayCommentBox(sample)">
                                            <div class="comment-box">
                                                <textarea [(ngModel)]="sample.comment" (input)="addComment(dataObj,j,i)"
                                                    [disabled]="isCommentsDisabled" placeholder="Enter your comment..."
                                                    required data-cy="sample-comment"></textarea>
                                            </div>
                                        </td>

                                    </tr>
                                </tbody>

                            </table>

                            <div *ngIf="selectedTargetName && searchResult.iteration==0">
                                <button data-cy="save-regression-button" [ngClass]="dataObj?.save ? 'btn btn-success' : 'btn btn-primary'"
                                    (click)="saveTargetDetails(selectedTargetName,i,dataObj)"
                                    [style.cursor]="dataObj?.save ? 'not-allowed' : 'pointer'"
                                    [disabled]="dataObj?.save || isRecalculateEnabled(dataObj)" style="float:left;">{{
                                    dataObj?.save ? 'Data Saved' : 'Save Regression and Continue' }}</button>
                            </div>
                            <div *ngIf="searchResult.iteration == 0">
                                <button class="btn btn-primary" style="float: right;" data-cy="refresh-button"
                                    (click)="refreshRegression(i,dataObj,false)"
                                    [disabled]="isRecalculateEnabled(dataObj)">
                                    Refresh
                                </button>
                            </div>
                            <div *ngIf="errormessage" style="width: 100%; margin-top: 10px;">
                                <p class="alert alert-danger">Unable to save data. Please contact administrator.</p>
                            </div>
                        </div>
                        <div *ngIf="!regressionApiError === '' ">
                            {{regressionApiError}}
                        </div>
                        <ng-template #Recalculate>
                            <div *ngIf="!fetchRegressionData">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Recalculating...
                            </div>
                            <div *ngIf="fetchRegressionData">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Saving Data...
                            </div>
                        </ng-template>
                    </mat-expansion-panel>
                    <br>
                </div>
                <div style="display: flex; gap: 12px; margin-top: 16px; align-items: flex-start; flex-wrap: wrap;">
                    <div *ngIf="showSubmitButton && searchResult.iteration==0 && selectedTargetName">
                        <button class="btn btn-primary" (click)="submitGraphDetails()" [disabled]="!submitEnabled"
                            style="min-width: 180px;" data-cy="submit-button">Submit and Lock Data
                            Results</button>
                    </div>
                </div>
            </div>

            <span *ngIf="submitResultLoader === true ">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Processing...
            </span>
            <div *ngIf="graphdata && selectedTargetName">
                <mat-paginator #RApaginator [length]="paginatedData" [pageSizeOptions]="[ 10, 20]"
                    showFirstLastButtons></mat-paginator>
            </div>

        </div>
    </div>

    <ng-container *ngIf="searchResult.analysisStatus==='Error'">
        <app-page-500 [display]=errorResult [analysisType]="searchResult.analysisType"></app-page-500>
    </ng-container>

    <ng-template #spin>
        <div class="main-div">
            <h5>{{analysisStatusText }} </h5>
            <br><br>
            <div class="dots-spinner">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
            </div>
        </div>
    </ng-template>

</card>